<template>
  <div
    v-if="perms && perms.stock && perms.stock == 1"
    class="card mb-25 border-0 rounded-0 bg-white"
  >
    <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing">
      <h4 class="card-title fw-bold mb-0">Statistiques du stock</h4>
      <div class="row">
        <div class="col-md-9">
          <!-- Replace with your rangedate-picker component -->
          <!-- <rangedate-picker
            ref="myInput"
            format="YYYY-MM-DD"
            i18n="EN"
            :preset-ranges="presetRanges"
            :captions="captions"
          /> -->
        </div>
        <div class="col-md-3">
          <button
            id="ingredients"
            aria-controls="intedient-list"
            style="margin-bottom: 22px"
            class="btn btn-primary mr-0 mr-sm-1 buttons"
            @click="FilterData"
          >
            <i class="flaticon-search"></i>
          </button>
          <button
            style="margin-bottom: 22px"
            class="btn btn-danger mr-0 mr-sm-1 buttons"
            @click="ClearFilterData"
          >
            <i class="flaticon-close"></i>
          </button>
        </div>
        <template v-if="!display">
          <div class="col-12">
            <table class="table content-table">
              <thead>
                <tr>
                  <th>Image</th>
                  <th>RÉFÉRENCE VARIANTE</th>
                  <th>PRODUITS</th>
                  <th>COLIS</th>
                  <th>COLIS LIVRÉS</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(post, index) in rows" :key="index">
                  <td>
                    <div
                      class="avatar rounded bg-light-company"
                      style="
                        width: 55px;
                        height: 55px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <img
                        style="height: 70px; width: 70px"
                        :src="
                          post && post.product_pic
                            ? post.product_pic
                            : require('@/assets/images/NoImage.png')
                        "
                        :alt="post && post.var_name ? post.var_name : 'No Name'"
                      />
                    </div>
                  </td>
                  <td>
                    <div class="font-weight-bold">
                      {{
                        post && post.inventory_ref ? post.inventory_ref : "N/A"
                      }}
                    </div>
                    <div class="small text-muted">
                      {{ post && post.var_name ? post.var_name : "N/A" }}
                    </div>
                  </td>
                  <td>{{ post && post.var_name ? post.var_name : "N/A" }}</td>
                  <td>
                    {{ post && post.total !== undefined ? post.total : 0 }}
                  </td>
                  <td>
                    {{
                      post &&
                      (post.DELIVERED !== undefined
                        ? post.DELIVERED
                        : post.delivered !== undefined
                        ? post.delivered
                        : 0)
                    }}
                    Colis Livrés
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-12">
            <nav aria-label="Page navigation">
              <ul class="pagination justify-content-center">
                <li
                  class="page-item"
                  :class="{ disabled: users.current_page === 1 }"
                >
                  <button
                    class="page-link"
                    @click="changePage(users.current_page - 1)"
                    :disabled="users.current_page === 1"
                  >
                    Précedent
                  </button>
                </li>

                <li
                  v-for="page in users.last_page"
                  :key="page"
                  class="page-item"
                  :class="{ active: users.current_page === page }"
                >
                  <button class="page-link" @click="changePage(page)">
                    {{ page }}
                  </button>
                </li>

                <li
                  class="page-item"
                  :class="{ disabled: users.current_page === users.last_page }"
                >
                  <button
                    class="page-link"
                    @click="changePage(users.current_page + 1)"
                    :disabled="users.current_page === users.last_page"
                  >
                    Suivant
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { computed } from "vue";
import { ref } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const auth = useAuthStore();

    const rows = ref<any[]>([]); // make sure rows starts as an array
    const itemsPerPage = 10;
    const currentPage = ref(1);

    const totalPages = computed(() => {
      const total = Math.ceil((rows.value?.length || 0) / itemsPerPage);
      return total > 0 ? total : 1; // fallback to 1 page
    });

    let perms = ref<any>({});
    perms.value = auth.permissions || {};

    const display = ref(true);
    const fields = ref([
      { key: "var_name", label: "Référence Variante" },
      { key: "name", label: "Produits" },
      // { key: 'views', label: 'VIEWS' },
      // { key: 'revenue', label: 'REVENUE' },
      { key: "total", label: "Colis" },
      { key: "delivered", label: "Colis Livrés" },
    ]);

    const users = ref({
      searchTerm: "",
      total: 0,
      last_page: 1,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
      searchEDate: "",
      searchSDate: "",
    });

    const loadMore = async () => {
      if (perms.value && perms.value.stock && perms.value.stock == 1) {
        display.value = true;
        try {
          const response = await api.get(
            `/api/auth/client/topProductS?searchSDate=${
              users.value.searchSDate || ""
            }&searchEDate=${users.value.searchEDate || ""}&page=${
              users.value.current_page
            }&limit=${users.value.per_page}`
          );

          rows.value = response.data.data.data; // 👈 rows are inside `data.data`
          users.value = {
            ...users.value,
            ...response.data.data, // merge pagination info
          };
        } finally {
          display.value = false;
        }
      }
    };

    const changePage = (page: number) => {
      if (page < 1 || page > users.value.last_page) return;
      users.value.current_page = page;
      loadMore(); // fetch new page
    };

    const FilterData = () => {
      // const myInput = (refs as any).myInput;
      // users.value.searchSDate = myInput?.dateRange?.start
      // ? convert(myInput.dateRange.start)
      // : '';
      // users.value.searchEDate = myInput?.dateRange?.end
      // ? convert(myInput.dateRange.end)
      // : '';
      loadMore();
    };

    const ClearFilterData = () => {
      users.value.searchEDate = "";
      users.value.searchSDate = "";
      // const myInput = (refs as any).myInput;
      // if (myInput) myInput.dateRange = {};
      loadMore();
    };

    return {
      currentPage,
      totalPages,
      changePage,
      perms,
      rows,
      loadMore,
      display,
      ClearFilterData,
      FilterData,
      users
    };
  },
});
</script>
